<section class="reports-panel">
  <div class="header-section">
    <gc-text [variant]="'minorHeading'">{{
      'reportsMenu' | translate
    }}</gc-text>
    <gc-button
      [icon]="'x'"
      [variant]="'plain'"
      (clicked)="onReportMenuClicked($event)"
    />
  </div>
  <gc-dropdown-button
    [placeholder]="'reportsPanel.filterPlaceholder' | translate"
    [activeItemId]="activeReportType()"
    [compact]="true"
    (listItemClicked)="onReportTypeSelected($event)"
  >
    @for (option of availableReportTypeOptions(); track option.value) {
      <gc-list-item [label]="option.label | translate" [id]="option.value" />
    }
  </gc-dropdown-button>
  <gc-input-field
    [placeholder]="'reportsPanel.searchPlaceholder' | translate"
    [icon]="'magnifyingGlass'"
    [value]="searchValue()"
    [showClearIcon]="true"
    (changed)="onSearchChanged($event)"
  />
  <gc-checkbox
    [label]="'reportsPanel.hideCompleted' | translate"
    [checked]="hideCompletedReports()"
    (changed)="onHideCompletedReportsChanged($event)"
  />
  @if (reportRows().length) {
    <ipo-flexible-table
      class="reports-panel-table"
      [dataSet]="reportRows()"
      [columns]="columns | translateArray: (language$ | async)! : 'header'"
      [clickableRows]="true"
      [markRowFn]="markSelectedRow(selectedReportId())"
      (rowClicked)="onReportRowClicked($event)"
    >
      <ng-template ipoTableColumn="name" let-report>
        {{ report.name }}
      </ng-template>
      <ng-template ipoTableColumn="status" let-report>
        {{ 'reportStatus.' + report.status | translate }}
      </ng-template>
    </ipo-flexible-table>
  } @else {
    <gc-text>{{ 'reportsPanel.empty' | translate }}</gc-text>
  }
</section>
